'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TranslatedContent = function () {
    function TranslatedContent(_ref) {
        var header = _ref.header,
            tokens = _ref.tokens,
            i18n = _ref.i18n,
            fallbackToInput = _ref.fallbackToInput;
        (0, _classCallCheck3.default)(this, TranslatedContent);

        this.header = header;
        this.tokens = tokens;
        this.i18n = i18n;
        this.fallbackToInput = fallbackToInput;
    }

    (0, _createClass3.default)(TranslatedContent, [{
        key: 'instance',
        value: function instance(prefix) {
            return {
                get: function (token, params) {
                    return this._get(prefix, token, params);
                }.bind(this)
            };
        }
    }, {
        key: '_get',
        value: function _get() {
            var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var token = arguments[1];
            var params = arguments[2];

            var originalInput = token;
            token = '' + prefix + token;
            var defaultValue = this.tokens[token];
            var str = '';
            var header = this.header;

            try {
                str = this.i18n.get(token, '', params);
            } catch (e) {}

            if (!str && defaultValue) {
                if (defaultValue.external) {
                    token = defaultValue.external;
                    defaultValue = '';
                    header = '';
                } else if (defaultValue.global) {
                    str = this._get('', defaultValue.global, params);
                }

                if (!str) {
                    try {
                        str = this.i18n.get('' + header + token, defaultValue, params);
                    } catch (e) {
                        console.log('[TranslatedContent]: couldn\'t find content');
                    }
                }
            }

            if (!str && this.fallbackToInput) {
                return originalInput;
            }

            return str;
        }
    }]);
    return TranslatedContent;
}();

exports.default = TranslatedContent;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/TranslatedContent.js
// module id = 1010
// module chunks = 0